<template>
  <div class="wt2-icon-with-text" :class="classObj">
    <span class="-icon wticon" :class="icon"></span>
    <span v-if="showText" class="-caption">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classObj() {
      return {
        '-active': this.active,
        '-disabled': this.disabled,
        '-badge': this.showBadge,
      };
    },
  },

  methods: {},
};
</script>
